import { Button, Text } from '@/components'
import { UtilityAccountDetails } from '@/app/features/utility-account-fields'
import { useViewModel } from './accountNumberViewModel'
import toExternalLink from '@/utils/to-external-link'
import { getValidUrl } from '@/utils/objectUtilities'

export default function AccountNumber() {
  const {
    config,
    upload,
    formik,
    register,
    utilityBillExampleSrc,
    utilityWebsiteLink,
    handleNext,
  } = useViewModel()

  // Don't re-ask for the bill when one is already on file (item 5); only show the
  // uploader once the user starts interacting with it this session.
  const alreadyUploaded =
    upload.hasStoredExtraction && upload.fileUploadStatus === 'idle'

  return (
    <UtilityAccountDetails
      alreadyUploaded={alreadyUploaded}
      title="Enter account details"
      subtitle={
        <Text variant="body2">
          Upload a utility bill and we'll find your account details
          automatically or enter them manually. You can find them on your bill
          or on your{' '}
          {utilityWebsiteLink ? (
            <a
              href={toExternalLink(getValidUrl(utilityWebsiteLink))}
              target="_blank"
              rel="noreferrer"
              className="text-link !underline !text-themed-blue-500 cursor-pointer"
            >
              utility's website
            </a>
          ) : (
            "utility's website"
          )}
          .
        </Text>
      }
      upload={{
        fileInputRef: upload.fileInputRef,
        handleFilesUploaded: upload.handleFilesUploaded,
        handleUploadClick: upload.handleUploadClick,
        fileUploadStatus: upload.fileUploadStatus,
        fileUploadName: upload.fileUploadName,
        uploadErrorMessage: upload.uploadErrorMessage,
        uploadSuccessMessage: upload.uploadSuccessMessage,
        billUrl: upload.billUrl ?? upload.persistedBillUrl,
        utilityBillExampleSrc,
      }}
      fields={{
        config,
        register,
        values: formik.values,
        errors: formik.errors,
        touched: formik.touched,
        // Include the persisted extraction (from an earlier step) so the
        // "Extracted from bill" hints show, not just fresh in-page uploads.
        extractedValues: {
          ...upload.persistedExtraction,
          ...upload.extractedValues,
        },
      }}
      footer={
        <Button
          id="account-number-next-button"
          variant="primary"
          onClick={handleNext}
        >
          Next
        </Button>
      }
    />
  )
}
